import React from 'react'
import { history } from '../store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchModules, fetchModuleDownloadCSV, fetchSNDownloadExcel } from '../actions/modules'
import { fetchMachines } from '../actions/machines'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from 'reactstrap';

import Box from '../components/Box'
import classnames from 'classnames';
import PropertyLabel from '../components/PropertyLabel'
import AssignedModuleList from '../components/AssignedModuleList'
import LoadingProgress from '../components/LoadingProgress'

import ModuleList from '../components/ModuleList'
import ModuleErrorList from '../components/ModuleErrorList'
import ErrorMessage from '../components/ErrorMessage'

import '../styles/ModulesView.css'


class ModulesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: this.props.type === 'PRODUCCION' ? '2' : '1',
      searchModalOpen: false,
      searchQuery: '',
      filterQuery: '',
      globalFilter: '',
      loading: false
    }

    this.handleModuleDownloadCSV = this.handleModuleDownloadCSV.bind(this);
    this.handleSNDownloadExcel = this.handleSNDownloadExcel.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleGlobalFilterChange = this.handleGlobalFilterChange.bind(this);
  }

  componentDidMount() {
    this.props.fetchModules()
    this.props.fetchMachines()
  }

  goTo(Code, e) {
    history.push(`/modules/${Code}`)
  }

  handleGlobalFilterChange(e) {
    const value = e.target.value;
    this.setState({ globalFilter: value });
  }

  toggleSearchModal = () => {
    this.setState(prevState => ({ searchModalOpen: !prevState.searchModalOpen, searchQuery: '' }));
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  printDuplicatedSN() {
    const { modules, machines } = this.props;

    if (!modules || !machines) {
      return <LoadingProgress />
    }

    // Create an object to store the counts of each SN
    const snCounts = {};

    // Iterate through machines and then through each module
    machines.forEach((machine) => {

      if (machine.Serial !== "VLK00000" && machine.Serial !== "VLK00001" && machine.Serial !== "SHOWROOM-O" && machine.Serial !== "SHOWROOM-I") {

        let index = 0;

        machine.Modules.forEach((mod) => {
          // Find the corresponding module in 'modules' that fits mod.Code
          const correspondingModule = modules.find(module => module.Code === mod.serialNumber);

          if (correspondingModule) {

            // Iterate through RegisterLockers of the corresponding module
            correspondingModule.RegisterLockers.forEach((lock) => {
              const { SN } = lock;

              if (!/^0+$/.test(SN)) {
                if (snCounts[SN]) {
                  snCounts[SN].count += 1;
                  snCounts[SN].module.push(mod.serialNumber);
                  snCounts[SN].machine.push(machine.Serial);
                  snCounts[SN].position.push(`${machine.FirstIndex + index}`);
                } else {
                  snCounts[SN] = {
                    count: 1,
                    module: [mod.serialNumber],
                    machine: [machine.Serial],
                    position: [`${machine.FirstIndex + index}`],
                  };
                }
              }

              index++;
            });
          }
        });
      }
    });

    // Find the maximum number of modules for a single SN
    const maxModules = Object.values(snCounts).reduce((max, item) => Math.max(max, item.module.length), 0);

    // Filter the SNs that have duplicates
    const globalFilter = (this.state.globalFilter || '').trim().toLowerCase();
    const duplicates = Object.entries(snCounts).filter(([SN, data]) =>
      data.count > 1 &&
      (!globalFilter || SN.toLowerCase().includes(globalFilter) || data.module.some(m => m.toLowerCase().includes(globalFilter)))
    );

    return (
      <div className="table-responsive">
        {duplicates.length > 0 ? (
          <table className="table table-hover table-clickable">
            <thead className="thead-dark">
              <tr>
                <th>DUPLICATED SN</th>
                {[...Array(maxModules)].map((_, index) => <th key={index} colSpan="3">Module {index + 1}</th>)}
              </tr>
            </thead>
            <tbody>
              {duplicates.map(([SN, data]) => (
                <tr key={SN}>
                  <td>{SN}</td>
                  {[...Array(maxModules)].flatMap((_, index) => [
                    <td style={{ borderLeft: '2px solid #067ddb' }} key={index}>Index: {data.position[index] || ''}</td>,
                    <td key={index}>Kiosk: {data.machine[index] || ''}</td>,
                    <td style={{ borderRight: '2px solid #067ddb' }} key={index}>Module: {data.module[index] || ''}</td>
                  ])}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No duplicate SNs found. Aleluyah equipo, por fin lo hemos conseguido! Aaaaaaaaaveee Maaariiiiiiiiaaaaaaa, pleeeenaaaa de graaaciaaaaa esttt...</p>
        )}
      </div>
    );
  }

  printModulesByCustomer() {

    const { machines, modules } = this.props;

    if (!machines || !modules) {
      return <LoadingProgress />
    }

    // Group modules by customer and calculate totals
    const modulesByCustomer = {};
    machines.forEach(machine => {
      const customerName = machine.Customer?.Fullname || 'None';

      if (!modulesByCustomer[customerName]) {
        modulesByCustomer[customerName] = {
          modules: [],
          totals: {} // Track totals for each module type
        };
      }

      // Concatenate modules for each machine
      modulesByCustomer[customerName].modules = modulesByCustomer[customerName].modules.concat(machine.Modules);

      // Count module types
      machine.Modules.forEach(module => {
        const moduleType = module.serialNumber?.substring(0, 5) || 'NONE'; // Assuming the module type is the first 5 characters
        modulesByCustomer[customerName].totals[moduleType] = (modulesByCustomer[customerName].totals[moduleType] || 0) + 1;
      });
    });

    const totalModules = Object.values(modulesByCustomer).reduce((sum, c) => sum + c.modules.length, 0);
    const filter = (this.state.globalFilter || '').trim().toLowerCase();

    // KPIs: cross-reference with module store data
    const allSerials = Object.values(modulesByCustomer).flatMap(c => c.modules.map(m => m.serialNumber));
    let pinchoCount = 0, slideCount = 0, bleCount = 0, publicCount = 0,
        wideCount = 0, chargeCount = 0, totalLockers = 0;
    allSerials.forEach(sn => {
      const mod = modules.find(m => m.Code === sn);
      if (!mod) { pinchoCount++; bleCount++; return; }
      if (!mod.HardType || mod.HardType == 2) pinchoCount++; else slideCount++;
      if (mod.ModeType == 1 || mod.ModeType == 2) publicCount++;
      else bleCount++;
      if (mod.Wide === 'W') wideCount++;
      if (mod.Mode === 'C') chargeCount++;
      totalLockers += (mod.RegisterLockers?.length || 0);
    });

    // Render cards per customer
    return (
      <div>
        {/* Summary bar */}
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 20 }}>
          <span style={{ background: '#022040', color: '#fff', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
            {Object.keys(modulesByCustomer).length} clientes
          </span>
          <span style={{ background: '#eef2f8', color: '#3a5a80', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
            <i className="fas fa-th-large mr-1"></i>{totalModules} módulos
          </span>
          <span style={{ background: '#e8f5e9', color: '#2e7d32', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
            <i className="fas fa-lock mr-1"></i>{totalLockers} taquillas
          </span>
          <span style={{ background: '#e8f4fd', color: '#1a6fa8', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
            <i className="fas fa-thumbtack mr-1"></i>Pincho: {pinchoCount}
          </span>
          <span style={{ background: '#fef3e2', color: '#b85c00', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
            <i className="fas fa-arrows-alt-h mr-1"></i>Slide: {slideCount}
          </span>
          <span style={{ background: '#f3e8ff', color: '#6b21a8', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
            <i className="fab fa-bluetooth mr-1"></i>Bluetooth: {bleCount}
          </span>
          {publicCount > 0 && (
            <span style={{ background: '#fce4ec', color: '#c62828', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
              <i className="fas fa-globe mr-1"></i>Public: {publicCount}
            </span>
          )}
          {wideCount > 0 && (
            <span style={{ background: '#fff8e1', color: '#f57f17', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
              <i className="fas fa-expand-arrows-alt mr-1"></i>Wide: {wideCount}
            </span>
          )}
          {chargeCount > 0 && (
            <span style={{ background: '#e8f5e9', color: '#558b2f', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>
              <i className="fas fa-charging-station mr-1"></i>Carga: {chargeCount}
            </span>
          )}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {Object.keys(modulesByCustomer).sort().map(customerName => {
            const { modules: allCustModules, totals } = modulesByCustomer[customerName];
            const custModules = filter
              ? allCustModules.filter(m => m.serialNumber?.toLowerCase().includes(filter))
              : allCustModules;

            if (custModules.length === 0) return null;
            return (
              <div key={customerName} style={{
                background: '#fff',
                border: '1px solid #dde3ec',
                borderRadius: 10,
                overflow: 'hidden',
                boxShadow: '0 2px 6px rgba(0,0,0,0.06)'
              }}>
                {/* Card header */}
                <div style={{
                  background: 'linear-gradient(135deg, #022040 0%, #0a4080 100%)',
                  padding: '10px 14px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: 13 }}>
                    <i className="fas fa-user mr-2"></i>{customerName}
                  </span>
                  <span style={{ background: 'rgba(255,255,255,0.2)', color: '#fff', borderRadius: 10, padding: '2px 9px', fontSize: 11, fontWeight: 700 }}>
                    {custModules.length}
                  </span>
                </div>

                {/* Totals row */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: '10px 14px', borderBottom: '1px solid #eef2f8' }}>
                  {Object.entries(totals).map(([moduleType, count]) => (
                    <span key={moduleType} style={{
                      background: '#eef2f8', color: '#022040',
                      borderRadius: 5, padding: '2px 8px',
                      fontSize: 11, fontWeight: 700
                    }}>
                      {moduleType} <span style={{ color: '#0a4080' }}>×{count}</span>
                    </span>
                  ))}
                </div>

                {/* Module pills */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, padding: '10px 14px' }}>
                  {custModules.map(module => (
                    <span
                      key={module.serialNumber}
                      onClick={() => this.goTo(module.serialNumber)}
                      style={{
                        background: '#f4f6fa',
                        border: '1px solid #dde3ec',
                        color: '#022040',
                        borderRadius: 5,
                        padding: '3px 8px',
                        fontSize: 11,
                        fontWeight: 600,
                        cursor: 'pointer',
                        transition: 'background 0.15s'
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#dde8f8'}
                      onMouseLeave={e => e.currentTarget.style.background = '#f4f6fa'}
                    >
                      {module.serialNumber}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  handleModuleDownloadCSV() {
    const { fetchModuleDownloadCSV } = this.props

    this.setState({ loading: true });

    fetchModuleDownloadCSV()
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleSNDownloadExcel() {
    const { fetchSNDownloadExcel } = this.props

    this.setState({ loading: true });

    fetchSNDownloadExcel()
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { role, type, modules, error, machines } = this.props
    const { globalFilter } = this.state

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!modules || !machines) {
      return <LoadingProgress />
    }

    const filteredModules = globalFilter
      ? modules.filter(m => m.Code.toLowerCase().includes(globalFilter.toLowerCase()))
      : modules

    const countByPrefix = (prefix) => filteredModules.filter(m => m.Code.substring(0, 5) === prefix).length

    const countErrors = filteredModules.filter(m => m.Code.substring(0, 3) !== 'VLM' && m.Code.substring(0, 3) !== 'VLK').length

    const countDuplicatedSN = () => {
      const snCounts = {}
      machines.forEach(machine => {
        if (machine.Serial !== 'VLK00000' && machine.Serial !== 'VLK00001' && machine.Serial !== 'SHOWROOM-O' && machine.Serial !== 'SHOWROOM-I') {
          machine.Modules.forEach(mod => {
            const correspondingModule = filteredModules.find(m => m.Code === mod.serialNumber)
            if (correspondingModule) {
              correspondingModule.RegisterLockers.forEach(lock => {
                const { SN } = lock
                if (!/^0+$/.test(SN)) {
                  if (!snCounts[SN]) snCounts[SN] = { count: 0, modules: [] }
                  snCounts[SN].count += 1
                  snCounts[SN].modules.push(mod.serialNumber)
                }
              })
            }
          })
        }
      })
      const filter = globalFilter.trim().toLowerCase()
      return Object.entries(snCounts).filter(([SN, data]) =>
        data.count > 1 &&
        (!filter || SN.toLowerCase().includes(filter) || data.modules.some(m => m.toLowerCase().includes(filter)))
      ).length
    }

    const allTabs = [
      ...(role === 'ADMIN' && type !== 'PRODUCCION' ? [{ id: '1', label: 'Por Cliente', count: null }] : []),
      { id: '2',  label: 'VLK04', count: countByPrefix('VLK04') },
      { id: '3',  label: 'VLK06', count: countByPrefix('VLK06') },
      { id: '13', label: 'VLK08', count: countByPrefix('VLK08') },
      { id: '12', label: 'VLM01', count: countByPrefix('VLM01') },
      { id: '4',  label: 'VLM02', count: countByPrefix('VLM02') },
      { id: '5',  label: 'VLM04', count: countByPrefix('VLM04') },
      { id: '6',  label: 'VLM06', count: countByPrefix('VLM06') },
      { id: '7',  label: 'VLM08', count: countByPrefix('VLM08') },
      { id: '8',  label: 'VLM10', count: countByPrefix('VLM10') },
      { id: '9',  label: 'VLM12', count: countByPrefix('VLM12') },
      { id: '10', label: 'Error', count: countErrors },
      ...(role === 'ADMIN' && type !== 'PRODUCCION' ? [{ id: '11', label: 'SN Duplicados', count: countDuplicatedSN() }] : []),
    ]

    // When filtering, hide tabs with 0 results (keep non-count tabs always)
    const tabs = globalFilter
      ? allTabs.filter(t => t.count === null || t.count > 0)
      : allTabs

    // If the active tab was hidden by the filter, switch to first visible tab
    const activeTab = tabs.find(t => t.id === this.state.activeTab)
      ? this.state.activeTab
      : (tabs[0]?.id || this.state.activeTab)

    return (
      <div className="modules-view">

        {/* ── Header ───────────────────────────────── */}
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-th-large mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">Módulos</span>
              </h1>
            </div>
            <div className="header-actions">
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <i className="fas fa-search" style={{ position: 'absolute', left: 10, color: '#94a3b8', fontSize: 13, pointerEvents: 'none' }}></i>
                <input
                  type="text"
                  placeholder="Filtrar módulos..."
                  value={globalFilter}
                  onChange={this.handleGlobalFilterChange}
                  style={{
                    paddingLeft: 32,
                    paddingRight: globalFilter ? 28 : 12,
                    paddingTop: 8,
                    paddingBottom: 8,
                    border: '1px solid #dde3ec',
                    borderRadius: 8,
                    fontSize: 13,
                    width: 200,
                    outline: 'none'
                  }}
                />
                {globalFilter && (
                  <button
                    type="button"
                    onClick={() => this.setState({ globalFilter: '' })}
                    style={{ position: 'absolute', right: 8, background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: 14, padding: 0, lineHeight: 1 }}
                  >&#x2715;</button>
                )}
              </div>
            </div>
            {(role === 'ADMIN' && (type === 'MASTER' || type === 'PROVEEDOR' || type === 'PRODUCCION')) && (
              <div className="header-actions">
                {this.state.loading ? (
                  <div className="loading-wheel"></div>
                ) : (
                  <>
                    <button className="mach-admin-btn secondary" onClick={this.toggleSearchModal}>
                      <i className="fas fa-search"></i>
                      <span>Buscar</span>
                    </button>
                    <button className="mach-admin-btn success" onClick={this.handleModuleDownloadCSV}>
                      <i className="fas fa-file-excel"></i>
                      <span>Módulos CSV</span>
                    </button>
                    <button className="mach-admin-btn warning" onClick={this.handleSNDownloadExcel}>
                      <i className="fas fa-file-excel"></i>
                      <span>SN Excel</span>
                    </button>
                    <Link to="/modules/add" className="mach-admin-btn primary" style={{ color: 'white' }}>
                      <i className="fas fa-plus"></i>
                      <span>Nuevo</span>
                    </Link>
                  </>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ── Tab card ─────────────────────────────── */}
        <div className="modules-tab-card">
          <div className="modules-tab-strip">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`modules-tab-btn${activeTab === tab.id ? ' active' : ''}`}
                onClick={() => this.toggle(tab.id)}
              >
                {tab.label}
                {tab.count !== null && (
                  <span className="modules-tab-badge">{tab.count}</span>
                )}
              </button>
            ))}
          </div>

          <div className="modules-tab-body">
            {activeTab === '1'  && this.printModulesByCustomer()}
            {activeTab === '2'  && <ModuleList modules={filteredModules} prefix='VLK04' />}
            {activeTab === '3'  && <ModuleList modules={filteredModules} prefix='VLK06' />}
            {activeTab === '13' && <ModuleList modules={filteredModules} prefix='VLK08' />}
            {activeTab === '12' && <ModuleList modules={filteredModules} prefix='VLM01' />}
            {activeTab === '4'  && <ModuleList modules={filteredModules} prefix='VLM02' />}
            {activeTab === '5'  && <ModuleList modules={filteredModules} prefix='VLM04' />}
            {activeTab === '6'  && <ModuleList modules={filteredModules} prefix='VLM06' />}
            {activeTab === '7'  && <ModuleList modules={filteredModules} prefix='VLM08' />}
            {activeTab === '8'  && <ModuleList modules={filteredModules} prefix='VLM10' />}
            {activeTab === '9'  && <ModuleList modules={filteredModules} prefix='VLM12' />}
            {activeTab === '10' && <ModuleErrorList modules={filteredModules} />}
            {activeTab === '11' && this.printDuplicatedSN()}
          </div>
        </div>

        {/* ── Search modal ─────────────────────────── */}
        <Modal isOpen={this.state.searchModalOpen} toggle={this.toggleSearchModal}>
          <ModalHeader toggle={this.toggleSearchModal}>Buscar Módulo por Código</ModalHeader>
          <ModalBody>
            {this.state.searchModalOpen && (
              <>
                <Input
                  type="text"
                  placeholder="Ingrese el código..."
                  value={this.state.searchQuery}
                  onChange={this.handleSearchChange}
                />
                <hr />
                <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className="table table-hover">
                    <thead>
                      <tr><th>Código</th></tr>
                    </thead>
                    <tbody>
                      {this.props.modules
                        .filter(mod => mod.Code.toLowerCase().includes(this.state.searchQuery.toLowerCase()))
                        .map(mod => (
                          <tr
                            key={mod.Code}
                            onClick={() => { this.goTo(mod.Code); this.toggleSearchModal(); }}
                            style={{ cursor: 'pointer' }}
                          >
                            <td>{mod.Code}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSearchModal}>Cerrar</Button>
          </ModalFooter>
        </Modal>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  modules: state.modules.modules,
  machines: state.machines.machines,
  error: state.modules.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchModules: bindActionCreators(fetchModules, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchModuleDownloadCSV: bindActionCreators(fetchModuleDownloadCSV, dispatch),
  fetchSNDownloadExcel: bindActionCreators(fetchSNDownloadExcel, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ModulesView)
